import $ from "jquery";
import "slick-carousel";

const contenctSliderCustomShowArrow = () => {
  const init = () => {
    exec();
  };

  const exec = () => {
    const el = {
      showArrow: ".content-slider-custom .show-arrow",
      slickArrow: ".content-slider-custom .show-arrow .slick-arrow",
      slickList: ".content-slider-custom .show-arrow .slick-list",
    };

    if ($(el.showArrow).length === 0) return;

    if ($(el.slickArrow).length === 0) {
      $(el.slickList).parent().addClass("no-margin-top");
    }
  };

  init();
};
try {
  contenctSliderCustomShowArrow();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
